"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "due-carrare": {
    "73db6a3d": [{
      "hkey": "715baf92",
      "slug": "due-carrare",
      "name": "Due Carrare",
      "primary": true,
      "skipSearch": false
    }],
    "cuccara-palazzina": [{
      "hkey": "715baf92",
      "slug": "due-carrare",
      "name": "Due Carrare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "301c986f": [{
      "hkey": "77c0f2e2",
      "slug": "mezzavia-terradura",
      "name": "Mezzavia-Terradura",
      "primary": true,
      "skipSearch": false
    }],
    "mezzavia": [{
      "hkey": "77c0f2e2",
      "slug": "mezzavia-terradura",
      "name": "Mezzavia-Terradura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "316c9539": [{
      "hkey": "77c0f2e2",
      "slug": "mezzavia-terradura",
      "name": "Mezzavia-Terradura",
      "primary": true,
      "skipSearch": false
    }],
    "terradura": [{
      "hkey": "77c0f2e2",
      "slug": "mezzavia-terradura",
      "name": "Mezzavia-Terradura",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "due-carrare"
    }]
  }
};
exports["default"] = _default;